<template>
 <div style="width: 100%">
    <ion-grid>
      <ion-row style="height: 100%;" justify-content-center>
        <ion-col align-self-center size-md="5" size-lg="5" size-xs="12">
          <div style="margin: 2em 0 1em; width: 100%;" text-center>
            <!-- <img src="http://placehold.it/300x200" /> -->
            <img src="img/lawyerly-invert.logo.png" style="width: 80%; margin: auto;" />
            <!-- <h4>Login Form</h4> -->
          </div>
          <div padding v-if="!isSent">
            <ion-item>
              <ion-input
                v-ion-model="email"
                type="text"
                placeholder="Email"
              ></ion-input>
            </ion-item>
          </div>
          <div padding class="center-content" v-if="!isSent">
            <ion-button @click="passwordReset" expand="block">
              Reset Password
            </ion-button>
          </div>
          <span class="error-text">{{ authStatus }}</span>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>
<script>
import { firebase as $firebase } from "@/firebase";
export default {
  data() {
    return {
      email: "",
      isSent: false,
      toastTimeout: 2000,
      authStatus: ""
    };
  },

  computed: {},

  methods: {
    back() {
      this.$router.go(-1);
      // this.showIndicator();
    },

    passwordReset() {
      if (this.isSent) {
        return;
      }

      if (this.email.length < 4 || !this.validateEmail(this.email)) {
        this.$ionic.showToast("Please enter a valid email address", {
          duration: this.toastTimeout
        });
        return;
      }

      // var passwordCheck = this.checkPassword()
      // if (passwordCheck.type !== '') {
      //   this.$root.$emit('toast', passwordCheck)
      //   return
      // }

      // this.$root.$emit('indicator', true)
      $firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.authStatus = "Password reset has been sent to your email.";
          this.isSent = true;
          // this.$router.replace('/auth/login')
        })
        .catch(error => {
          // Handle Errors here.
          // const errorCode = error.code
          const errorMessage = error.message;
          this.authStatus = errorMessage;
        })
        .finally(() => {
          // this.$root.$emit('indicator', false)
        });
    },

    validateEmail(email) {
      /* eslint-disable no-useless-escape */
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(String(email).toLowerCase());
    }
  },

  mounted() {}
};
</script>

<style lang="scss">
ion-grid {
  width:100%;
  height: 100%;
  --background: #dfdfdf;
}
.error-text {
  color: #f44336;
  text-align: center;
  margin: 40px 0 15px 0;
  width: 100%;
  display: block;
  font-weight: 600;
}
</style>
